<template>
  <div class="market-section">
    <!-- 标题：红色竖线 + 标题文字 -->
    <div class="market-section__header">
      <span class="market-section__indicator"></span>
      <span class="market-section__title">{{ title }}</span>
    </div>

    <!-- 新闻列表（固定3条） -->
    <div
      v-for="(item, idx) in displayItems"
      :key="idx"
      class="market-section__item"
      @click="goDetail(item)"
    >
      <!-- 分割线（条目之间） -->
      <div v-if="idx > 0" class="market-section__divider"></div>
      <div class="market-section__item-inner">
        <span class="market-section__item-title">{{ item.title }}</span>
        <span class="market-section__item-meta">{{ item.categoryName }}&nbsp;&nbsp;&nbsp;&nbsp;{{ item.publishTime }}</span>
      </div>
    </div>

    <!-- 最后一条下方的横线 -->
    <div class="market-section__divider"></div>
  </div>
</template>

<script>
import { getNewsList } from '../../../api/news';

export default {
  name: 'MarketSupervision',
  props: {
    title: { type: String, default: '市场监管' }
  },
  data() {
    return {
      newsList: []
    };
  },
  computed: {
    displayItems() {
      return this.newsList.slice(0, 3); // 固定取前3条
    }
  },
  mounted() {
    this.loadNews();
  },
  methods: {
    async loadNews() {
      try {
        const res = await getNewsList({ categoryIdList: [1] });
        const data = res.data;
        this.newsList = Array.isArray(data) ? data : (data.records || data.list || data.rows || []);
      } catch (err) {
        console.error('获取市场监管新闻失败', err);
        this.newsList = [];
      }
    },
    goDetail(item) {
      if (!item.newsCode) return;
      this.$router.push(`/detail?newsCode=${item.newsCode}`);
    }
  }
};
</script>

<style scoped>
.market-section {
  width: var(--content-width);
}

/* ── 标题区域 ── */
.market-section__header {
  display: flex;
  align-items: center;
  height: 44px;
  margin-bottom: 16px;
}

.market-section__indicator {
  display: block;
  width: 6px;
  height: 30px;
  background-color: var(--color-primary);
  border-radius: var(--radius-full);
  flex-shrink: 0;
}

.market-section__title {
  color: var(--color-black);
  font-size: var(--font-2xl);
  font-family: var(--font-primary);
  font-weight: var(--weight-bold);
  white-space: nowrap;
  line-height: 30px;
  margin-left: var(--space-2);
}

/* ── 新闻条目 ── */
.market-section__item {
  width: var(--content-width);
  cursor: pointer;
}

.market-section__divider {
  width: var(--content-width);
  height: 1px;
  background-color: #EBEBEB;
}

.market-section__item-inner {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 20px 0;
}

.market-section__item-title {
  display: block;
  width: var(--content-width);
  height: 40px;
  color: var(--color-black);
  font-size: var(--font-2xl);
  font-family: var(--font-primary);
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 30px;
}

.market-section__item-meta {
  display: block;
  width: 325px;
  height: 28px;
  color: var(--color-text-light);
  font-size: var(--font-base);
  font-family: var(--font-primary);
  text-align: left;
  white-space: nowrap;
  line-height: 18px;
  margin-top: 9px;
}
</style>
